import * as React from 'react';

export const useStopPulseAnimationListener = (
  badgeRef: React.RefObject<HTMLSpanElement | null>
): boolean => {
  const [stopPulseAnimation, setStopPulseAnimation] =
    React.useState<boolean>(false);

  React.useEffect(() => {
    const badgeElement = badgeRef?.current;
    if (!badgeElement) return;
    const events = ['mouseenter', 'focus'];

    const handleMouseEnterOrFocus = (): void => {
      setStopPulseAnimation(true);
    };

    events.forEach((event) =>
      badgeElement.addEventListener(event, handleMouseEnterOrFocus, {
        once: true,
      })
    );

    return () => {
      events.forEach((event) =>
        badgeElement.removeEventListener(event, handleMouseEnterOrFocus)
      );
    };
  }, [badgeRef]);

  return stopPulseAnimation;
};
